import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from '@chakra-ui/react';
import { useError, useSuccess } from '@pelicargo/ui';
import { useState } from 'react';

import { trpc } from '../config/trpc';

const MIN_PASSWORD_LENGTH = 8;

type Props = {
  authId: string;
  isOpen: boolean;
  onClose: () => void;
};

export const SetTempPasswordModal = ({ authId, isOpen, onClose }: Props) => {
  const { handleSuccess } = useSuccess();
  const { handleError } = useError();
  const [password, setPassword] = useState('');
  const { mutateAsync: setUserTempPassword, isLoading } = trpc.setUserTempPassword.useMutation();

  const canSubmit = password.trim().length >= MIN_PASSWORD_LENGTH;

  const handleClose = () => {
    setPassword('');
    onClose();
  };

  const handleConfirm = async () => {
    try {
      await setUserTempPassword({ auth_id: authId, password });
      handleSuccess('Temp password set');
      handleClose();
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Set temp password</ModalHeader>
        <ModalBody>
          <Stack spacing={3}>
            <Text>
              Overwrites this user's current password. Share it with them securely and have them change it. This action
              will be logged.
            </Text>
            <Input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={`At least ${MIN_PASSWORD_LENGTH} characters`}
              autoComplete="new-password"
            />
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Stack direction="row">
            <Button onClick={handleClose}>Cancel</Button>
            <Button colorScheme="red" isLoading={isLoading} isDisabled={!canSubmit} onClick={handleConfirm}>
              Set password
            </Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
